module.exports = __webpack_public_path__ + "img/IT0001693318247.b9b1a3f5.png";